export const DASHBOARD_URL = '/dashboard/' as const;
export const DASHBOARD_NAV_URL =
  '/index.cfm?go=w.Welcome&prior=w.createSignUp&formName=registerForm' as const;
